import root from "./_root.js";
/** Used to detect overreaching core-js shims. */

var coreJsData = root['__core-js_shared__'];
export default coreJsData;